
import Input from "../Input";
import Output from "../Output";

import switchImage from "../../assets/switch.png";
import { Helmet } from 'react-helmet-async';
import { Link } from "react-router-dom";

import heber from "../../assets/heber.png"
import magyar from "../../assets/magyar.png"
import arrow from "../../assets/arrow.png"

function MagyarHeber({ handleText, output, handleTarget, handleSource, langs, handleSwap, handleTranslate, text }) {


    return (

        <>
            <Helmet>
                <title>Magyar héber fordító</title>
                <meta name='description' content="Ingyenes magyar héber fordító szavakra, kifejezésekre, mondatokra. Akár teljes szöveg fordítása is." />
                <meta title="Magyar héber fordító" />
                <link rel="canonical" href="https://online-fordito.hu/magyar-heber-fordito" />
            </Helmet>
            <h1>Magyar héber fordító</h1>
            <div className="wrapper">
                <div>
                    <Input handleText={handleText} handleSource={handleSource} langs={langs} text={text}></Input>
                    <button className="transbutton" onClick={handleTranslate}>Fordítás</button>
                </div>

                <button className="switch" onClick={handleSwap}><img src={switchImage}></img></button>


                <Output output={output} handleTarget={handleTarget} langs={langs} />

            </div>

            <section>


                <div className="sectionhead">
                    <h2>A magyar és héber nyelv </h2>
                    <img src={magyar} alt="magyar zászló"></img>
                    <img src={heber} alt="héber zászló"></img>
                </div>


                <p>Íme néhány fő hasonlóság és különbség a héber és a magyar között:</p>

                <h3>Hasonlóságok</h3>

                <li><b>Gazdag történelmi háttér</b>: A hébernek és a magyarnak egyaránt mély történelmi gyökerei vannak. A héber egy ősi sémi nyelv, amelynek vallási és kulturális jelentősége van a judaizmusban, míg a magyar gazdag nyelvtörténettel rendelkezik, eredete a finnugor nyelvcsaládból származik.</li>

                <li><b>Egyedi szókincs</b>: Mindkét nyelvnek vannak olyan szókészletei, amelyek nem állnak szorosan rokonok más európai nyelvekkel. A héber gyökerei az ókori sémi nyelvekből származnak, és arámi, arab és más nyelvekből kölcsönzött szavakat. A magyarnak megvan a maga egyedi szókincse, és a szomszédos nyelvekből kölcsönzött szavakat.</li>

                <h3>Különbségek</h3>

                <h4>Nyelvcsalád</h4>

                <ul>

                    <li><b>Héber</b>: A héber egy sémi nyelv, az afroázsiai nyelvcsalád része. Szorosan rokon más sémi nyelvekkel, mint az arab és az amhara.</li>
                    <li><b>Magyar</b>: A magyar finnugor nyelv, az uráli nyelvcsalád része. Nem kapcsolódik szorosan más európai nyelvekhez, és egyedülálló nyelvi örökséggel rendelkezik.</li>
                </ul>

                <h4>Nyelvtan</h4>

                <ul>
                    <li><b>Héber</b>: A hébernek összetett morfológiája van, igegyökökből, -mintákból és ragozásokból álló rendszerrel. Gazdag főnévi és igealakrendszerrel rendelkezik, beleértve a nemet, a számot és az igeidőt. A héber nyelvnek van egy nyelvtani esetrendszere és egy egyedi szerkezeti állapota a főnévi kifejezésekhez.</li>
                    <li><b>Magyar</b>: A magyarnak összetett agglutinatív nyelvtana van. A szótövekhez fűződő toldalékrendszert használja, hogy kifejezze az olyan nyelvtani jellemzőket, mint az idő, a mód, a szám és a birtoklás. A magyar nyelvben gazdag főnévi esetrendszer is található a nyelvtani szerepek jelzésére.</li>
                </ul>

                <h4>Ábécé</h4>

                <ul>
                    <li><b>Héber</b>: A héber saját egyedi ábécéjét használja, amelyet héber ábécéként ismernek. Ez egy abjad, mássalhangzókból áll, és magánhangzójeleket adnak hozzá a magánhangzók jelzésére.</li>
                    <li><b>Magyar</b>: A magyar a latin ábécét használja néhány további diakritikus jellel. 44 betűje van, beleértve a digráfokat és az ékezetes karaktereket.</li>
                </ul>

                <h4>Kiejtés</h4>

                <ul>

                    <li><b>Héber</b>: A hébernek saját egyedi kiejtési rendszere van, beleértve az eltérő mássalhangzó-hangokat és magánhangzó-mintákat. A kiejtés a regionális akcentusoktól és a vallási hagyományoktól függően változhat.</li>
                    <li><b>Magyar</b>: A magyar nyelvnek egyszerű hangrendszere van, következetes kiejtési szabályokkal. Ha megtanulja az egyes betűk és betűkombinációk kiejtését, könnyebbé válik a magyar szavak olvasása és kiejtése.</li>
                </ul>


                <div className="sectionbottom">
                    <Link to="/heber-magyar-fordito">Héber magyar fordító</Link>
                    <img src={heber} alt="héber zászló"></img>
                    <img src={arrow} alt=">"></img>
                    <img src={magyar} alt="magyar zászló"></img>
                </div>


            </section>


        </>

    )
}

export default MagyarHeber;